import State from '../core/State';
import initialState from '../initialState';
import { Offer } from '../service/persistent/offer/OfferWebApi';

export const startFetchingOffers = () => (state: State): State => ({
  ...state,
  offers: {
    ...state.offers,
    fetching: state.offers.fetching + 1,
  },
});

export const finishFetchingOffers = () => (state: State): State => ({
  ...state,
  offers: {
    ...state.offers,
    fetching: state.offers.fetching - 1,
  },
});

export const setOffers = (offers: Offer[], nextCursor: string | null) => (state: State): State => ({
  ...state,
  offers: {
    ...state.offers,
    items: offers,
    nextCursor,
  },
});

export const appendOffers = (offers: Offer[], nextCursor: string | null) => (state: State): State => ({
  ...state,
  offers: {
    ...state.offers,
    items: state.offers.items.concat(offers),
    nextCursor,
  },
});

export const dispose = () => (state: State): State => ({
  ...state,
  offers: initialState.offers,
});

export const setIsHideClosedOffer = (isHideClosedOffer: boolean) => (state: State): State => ({
  ...state,
  offers: {
    ...state.offers,
    isHideClosedOffer: isHideClosedOffer,
  },
});
